"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgLargeStatusRed = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none" }, props),
    React.createElement("path", { fill: "#AD5B52", fillRule: "evenodd", d: "M9.106.178a2.33 2.33 0 0 1 2.546.507l7.664 7.663a2.34 2.34 0 0 1 0 3.304l-7.664 7.664a2.336 2.336 0 0 1-3.303 0L.684 11.654a2.34 2.34 0 0 1 0-3.304L8.348.686c.216-.218.474-.39.758-.508", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M10.97 10.003a.985.985 0 0 1-.979.977.973.973 0 0 1-.965-.977V6.097c0-.534.417-.977.965-.977s.992.443.979.977zm-.927 1.966c.105 0 .21.013.314.066.626.156 1.108.703 1.108 1.393 0 .807-.665 1.458-1.474 1.458a1.457 1.457 0 0 1-1.461-1.458c0-.703.509-1.263 1.174-1.407a.8.8 0 0 1 .235-.052l.022-.005a.2.2 0 0 1 .043-.008q.01.001.02.007.01.005.02.006", clipRule: "evenodd" })));
exports.default = SvgLargeStatusRed;
